import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
} from "@mui/material";
import { callAPI } from "../../App/Helpers/callApi";
import Signifier from "../../App/Components/Signifier/Signifier";
import { useSelector } from "react-redux";
import { selectCareersClientValue } from "../../App/State/Slices/SelectedCareersClientSlice";
import Breadcrumb from "../../App/Components/Navigation/Breadcrumbs/Breadcrumbs";
import DropdownComponent from "../../App/Components/Dropdown/DropdownComponent";
import { editAncillaryConfig, getAncillaryConfig } from "./AncillaryService";
import { CheckRoleForClient } from "../../App/Helpers/PermissionsChecks";
import { Roles } from "../../App/Enums/Roles";
import { selectUserPermissionsValue } from "../../App/State/Slices/UserPermissionsSlice";

function AncillaryPage() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "70%",
      marginBottom: "50px",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    cardContainer: {
      [theme.breakpoints.down("md")]: {
        width: "100%",
        overflowY: "scroll",
      },
      display: "flex",
      flexDirection: "column",
      marginBottom: "20px",
      width: "50%",
    },
    error: {
      color: theme.palette.error.main,
    },
    copy: {
      color: theme.palette.primary.copy,
    },
  }));

  const classes = useStyles();

  const selectCareersClient = useSelector(selectCareersClientValue);
  const rolesObject = useSelector(selectUserPermissionsValue);
  const [showSignifier, setShowSignifier] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState("");

  const [displayMap, setDisplayMap] = useState(false);
  const [displaySimilar, setDisplaySimilar] = useState(false);
  const [numberOfJobs, setNumberOfJobs] = useState("");

  function saveAncillaryConfig() {
    let data = {
      ClientId: selectCareersClient.id,
      templateId: selectedTemplate.id,
      ancillaryConfig: {
        ClientId: selectCareersClient.id,
        HasMoreLikeThisData: displaySimilar,
        Size: numberOfJobs,
        HasLocationMap: displayMap,
      },
    };

    callAPI(
      editAncillaryConfig(data),
      "Ancillary Saved",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    ).then(() => {
      getAncillaryConfig(selectCareersClient.id).then((response) => {
        response.templates.push({ name: "None", id: "" });
        setTemplates(response.templates);
        setDisplaySimilar(response.ancillaryConfig?.hasMoreLikeThisData);
        setDisplayMap(response.ancillaryConfig?.hasLocationMap);
        setNumberOfJobs(
          response.ancillaryConfig?.size === undefined
            ? ""
            : response.ancillaryConfig?.size
        );
      });
    });
  }

  useEffect(() => {
    if (selectCareersClient !== null) {
      getAncillaryConfig(selectCareersClient.id).then((response) => {
        response.templates.push({ name: "None", id: "" });
        setTemplates(response.templates);
        setDisplaySimilar(response.ancillaryConfig?.hasMoreLikeThisData);
        setDisplayMap(response.ancillaryConfig?.hasLocationMap);
        setNumberOfJobs(response.ancillaryConfig?.size);
      });
    }
  }, [selectCareersClient]);

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <div className="page-container">
        <Breadcrumb />
        <h1 className="page-title">
          {selectCareersClient.shortName} Job Details Ancillary
        </h1>
        <div className={classes.root}>
          <Grid className={classes.cardContainer}>
            <Card className={classes.card}>
              <CardContent>
                <Grid container spacing={1}>
                  {CheckRoleForClient(
                    rolesObject,
                    selectCareersClient.id?.toUpperCase(),
                    Roles.SuperAdmin
                  ) ? (
                    <Grid item xs={12} sm={12}>
                      <DropdownComponent
                        currValue={selectedTemplate}
                        items={templates}
                        property="name"
                        title="Assign To Template"
                        handleChange={(value) => setSelectedTemplate(value)}
                      />
                    </Grid>
                  ) : null}
                  <Grid xs={12} sm={6} item>
                    <FormControlLabel
                      className={classes.copy}
                      style={{ marginTop: "10px" }}
                      control={
                        <Checkbox
                          color="primary"
                          checked={displayMap}
                          onChange={() => setDisplayMap(!displayMap)}
                        />
                      }
                      label="Display Map in Job Description"
                    />
                  </Grid>
                  <Grid xs={12} sm={6} item>
                    <FormControlLabel
                      className={classes.copy}
                      style={{ marginTop: "10px" }}
                      control={
                        <Checkbox
                          color="primary"
                          checked={displaySimilar}
                          onChange={() => setDisplaySimilar(!displaySimilar)}
                        />
                      }
                      label="Display Similar Jobs in Job Description"
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <TextField
                      placeholder="Number of Similar Jobs to Display"
                      label="Number of Similar Jobs to Display"
                      variant="standard"
                      fullWidth
                      type="number"
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={numberOfJobs}
                      onChange={(e) => setNumberOfJobs(e.target.value)}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    container
                    justifyContent="flex-end"
                  >
                    <Button
                      style={{ marginTop: "20px", marginRight: "8px" }}
                      className={classes.sensitiveButton}
                      type="submit"
                      variant="contained"
                      color="primary"
                      onClick={() => saveAncillaryConfig()}
                    >
                      Save Information
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </div>
      </div>
    </>
  );
}

export default AncillaryPage;
